export default __webpack_public_path__ + "e2cf3dc2f079bf3d5185a02552f153c4.woff";